import React, {Dispatch, SetStateAction, useMemo, useState} from 'react';
import {observer} from "mobx-react-lite";
import useOutsideClick from "../../../../hooks/useOutsideClick";
import styles from './styles.module.scss';

const SelectedIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M19.2573 7.22745C19.5502 7.52033 19.5503 7.9952 19.2574 8.28811L10.773 16.7734C10.6324 16.9141 10.4416 16.9931 10.2427 16.9931C10.0437 16.9931 9.85297 16.9141 9.71231 16.7735L5.46967 12.5308C5.17678 12.2379 5.17678 11.7631 5.46967 11.4702C5.76256 11.1773 6.23744 11.1773 6.53033 11.4702L10.2426 15.1824L18.1967 7.22751C18.4895 6.9346 18.9644 6.93458 19.2573 7.22745Z" fill="#1E1E1E"/>
        </svg>
    )
};

const ArrowDownIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M13.0176 7.5542L8.99972 11.5721L4.98186 7.5542" stroke="black" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export interface ISelectLang {
    value: string;
    isSelected: boolean;
}

interface IProps {
    langs: ISelectLang[];
    setLangs: Dispatch<SetStateAction<ISelectLang[]>>;
}

const SelectLang = ({langs, setLangs}:IProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleToggle = () => setIsOpen((prev) => !prev);
    const handleClose = () => setIsOpen(false);

    const handleSelectLang = (e:React.MouseEvent<HTMLButtonElement>) => {
        const value = e.currentTarget.id;
        setLangs((prev) => {
           return prev.map((item) => {
               return value === item.value ? {...item, isSelected: true} : {...item, isSelected: false}
           })
        })
        handleClose()
    };

    const seletedLang = useMemo(() => {
        return langs.find((item) => item.isSelected)?.value;
    },[langs]);


    const ref = useOutsideClick(handleClose);

    return (
        <div
            className={styles.lang}
            ref={ref}
        >
            <button
                className={styles.lang__select}
                onClick={handleToggle}
                type={'button'}
            >
                Language
                <span className={styles.lang__value}>
                    {seletedLang ? seletedLang : ''}
                </span>
                <ArrowDownIcon />
            </button>
            {isOpen ? (
                <div className={styles.lang__list}>
                    {langs.map((item) => {
                        return (
                            <button
                                className={styles.lang__item}
                                id={item.value}
                                type={'button'}
                                onClick={handleSelectLang}
                            >
                                {item.value}
                            </button>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};

export default observer(SelectLang);
